import { If, classNames } from "react-extras";
import get from "lodash/get";
import find from "lodash/find";
import moment from "moment";
import { formatMoney } from "../../../lib/format-money";
import React from "react";
import { useSelector } from "react-redux";
import Table from "../tables";
import "./transaction_table.scss";
import {
  CreatorInsertionCredit,
  PendingInvoiceTransaction,
  PendingInvoiceTransactionState,
  RecurringDonationCredit,
  SubscriptionSurchargeCredit,
  TipCredit,
} from "../../../constants/transactions";
import ExclusiveTag from "../exclusive_tag";
import { OverlayTrigger, Popover } from "react-bootstrap";

const columnInfo = [
  {
    accessor: "transactionDisplay",
    Cell: function Cell(a) {
      const isPending = a.original?.isPending ?? false;
      let classes = "flex-row-container transaction-row";
      if (isPending) {
        classes += " pending-opacity";
      }

      return (
        <div className={classes}>
          <If condition={!!get(a.value, "imageURL")}>
            <img
              src={`${get(a.value, "imageURL")}?d=100x100`}
              className={"album-art"}
              alt="album-art"
            />
          </If>
          <div className="transaction-display">
            <If condition={!!get(a.value, "title")}>
              <h4 className={"transaction-title"}>{get(a.value, "title", "No Title")}</h4>
            </If>
            <p className={"no-margin"}>
              {a.value.datePrefix}
              {moment(a.value.createdAt, "X").format("MMMM D, YYYY")}
            </p>
          </div>
        </div>
      );
    },
  },
  {
    accessor: "amount",
    Cell: a => {
      const isPending = a.original?.isPending ?? false;
      let classes = classNames("transaction-amount-column", {
        "pending-opacity": isPending,
      });
      return (
        <div className="flex-row-container">
          <If condition={isPending}>
            <OverlayTrigger
              trigger={["hover", "focus"]}
              placement="top"
              overlay={
                <Popover id="helper-text">
                  <div className="text-center">
                    Awaiting invoice payment
                    <br /> from the brand
                  </div>
                </Popover>
              }>
              <ExclusiveTag className="margin-right--small">AWAITING BRAND</ExclusiveTag>
            </OverlayTrigger>
          </If>
          <div className={classes}>{formatMoney(a.value / 1000)}</div>
        </div>
      );
    },
  },
];

const TransactionTable = props => {
  const { transactions, noDataText } = props;
  const shows = useSelector(state => state.shows.shows);
  const campaignItemByUUID = useSelector(state => state.campaignItems.campaignItemByUUID);
  const campaignItems = Object.values(campaignItemByUUID);

  if (!transactions) return null;

  const getTitle = transaction => {
    let titlePrefix = "";
    switch (transaction.type) {
      case SubscriptionSurchargeCredit:
        titlePrefix = `Subscription Payment`;
        break;
      case TipCredit:
      case RecurringDonationCredit:
        titlePrefix = `Donation Payment`;
        break;
      case PendingInvoiceTransaction:
      case CreatorInsertionCredit: {
        // TODO maybe come up with a better way to do this in the future
        // Currently we are using the fact that there is unique (showUUID, campaignUUID) for
        // a single campaignItem
        const showUUID = transaction.showUUID;
        const campaignUUID = transaction.campaignUUID;
        const campaignItem = find(campaignItems, {
          campaignUUID: campaignUUID,
          showUUID: showUUID,
        });

        const campaignName = campaignItem?.campaignName;
        titlePrefix = campaignName ? `Ad Payment from ${campaignName}` : "Ad Payment";
        break;
      }
      default:
    }

    return titlePrefix;
  };

  const data = transactions
    .slice()
    .reverse()
    .map(transaction => {
      return {
        ...transaction,
        isPending: transaction.state === PendingInvoiceTransactionState,
        transactionDisplay: {
          title: getTitle(transaction),
          imageURL: `${get(shows, [transaction.showUUID, "imageURL"], "")}`,
          createdAt: transaction.createdAt,
          datePrefix:
            transaction.state === PendingInvoiceTransactionState ? "Brand invoiced on: " : "",
        },
      };
    });

  if (data.length) {
    return (
      <div className="transaction-table">
        <Table
          data={data}
          columns={columnInfo}
          className="transaction-table"
          showPagination={false}
          getTheadProps={() => ({
            style: {
              display: "none",
            },
          })}
        />
      </div>
    );
  }
  return <div className="no-transactions text-center margin-vert--large">{noDataText}</div>;
};

export default TransactionTable;
